import errorTemplate from '../error-template';

export default response => {
  const {status, data: {validationMessage}} = response;

  throw errorTemplate(status, validationMessage);
};
